/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-16 17:30 VN — WEB-20261016-suzitee-pdp-price-wp
   Đã làm: thay popover "Estimated delivery timeline" (04:20 VN, hover/click nổi cạnh ngày) bằng popup "Delivery breakdown" Y HỆT WANDERPRINTS
   (đo getComputedStyle wanderprints.com 16/10): desktop = hộp giữa màn 560px bo 16px; mobile (<768px) = bottom sheet bo 16px trên; nền tối rgba(0,0,0,.4).
   Timeline 3 mốc (Order placed / Order shipped / Order delivered) — ngày đọc TRỰC TIẾP từ #orderPlaced1/#orderShips1/#orderDelivered1 (estimated-shipping,
   cùng nguồn với dòng "Order today and get it by") lúc mở => luôn khớp. Gạch đầu dòng = chính sách giao hàng THẬT của Suzitee (/policies/shipping-policy).
   Mở: bấm/Enter/Space vào ngày (#orderDelivered) hoặc tên nước ([data-sz-dpop-open]). Đóng: X, Got it, bấm nền, Esc. Có focus trap, aria-modal, khoá cuộn nền,
   trả focus về nút đã bấm. Không polling, không đo layout liên tục; DOM popup chỉ tạo lần đầu mở.
   AI Agent làm theo chỉ thị của anh Hoá — 2026-10-16 18:05 VN — WEB-20261016-suzitee-pdp-price-wp (rev PRICE-v1)
   Đã làm: đổi CÁCH HIỂN THỊ khoảng ngày sang kiểu WP "Oct 22 - Oct 26" (lặp tháng, cách 2 bên gạch; khác tháng "Oct 30 - Nov 3")
   ở dòng "Order today and get it by" (#orderDelivered) và 2 mốc trong popup. KHÔNG đổi logic tính ngày (snippets/estimated-shipping.liquid
   vẫn tính và ghi "Oct 22-26" lúc DOMContentLoaded; script này chỉ viết lại chữ). Bắt lần ghi đó bằng 1 MutationObserver HẸP chỉ trên
   chính #orderDelivered (childList/characterData), chỉ ghi khi chữ khác => lần ghi của mình không tự kích lại (fmt() idempotent). */
(function(){
  'use strict';
  try{
    var ov=null,dlg=null,lastFocus=null,isOpen=false,hideT=0;
    var POLICY=[
      'All items are made-to-order: we print your item just for you, one at a time.',
      'The above time frame is applied for orders to the US with standard shipping methods.',
      'International orders may take additional days if they have to go through customs.'
    ];
    var SV='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
    var IC={
      cart:SV+'<circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>',
      truck:SV+'<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
      check:SV+'<path d="M20 6 9 17l-5-5"/></svg>',
      x:SV+'<path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>'
    };
    /* "Oct 22-26" -> "Oct 22 - Oct 26"; "Oct 30-Nov 3" -> "Oct 30 - Nov 3"; chuỗi khác (vd "Oct 16", đã đúng dạng) giữ nguyên */
    var RANGE=/^([A-Za-z]{3,9}\.?) (\d{1,2}) ?- ?(?:([A-Za-z]{3,9}\.?) )?(\d{1,2})$/;
    function fmt(s){var t=String(s||'').replace(/\s+/g,' ').trim(),m=RANGE.exec(t);if(!m)return t;return m[1]+' '+m[2]+' - '+(m[3]||m[1])+' '+m[4];}
    function fixLine(){
      var d=document.getElementById('orderDelivered');if(!d)return;
      var t=d.textContent,f=fmt(t);if(f&&f!==t)d.textContent=f;
    }
    function txt(ids){for(var i=0;i<ids.length;i++){var e=document.getElementById(ids[i]);if(e&&e.textContent.trim())return e.textContent.trim();}return '';}
    function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
    function step(icon,key,label){return '<li class="sz-dbk__step"><span class="sz-dbk__ic">'+IC[icon]+'</span><span class="sz-dbk__txt"><span class="sz-dbk__date" data-k="'+key+'"></span><span class="sz-dbk__lbl">'+label+'</span></span></li>';}
    function build(){
      ov=document.createElement('div');ov.className='sz-dbk';ov.hidden=true;ov.setAttribute('data-sz-dbk','');
      ov.innerHTML='<div class="sz-dbk__dlg" role="dialog" aria-modal="true" aria-labelledby="szDbkTitle" tabindex="-1">'+
        '<div class="sz-dbk__head"><h2 class="sz-dbk__title" id="szDbkTitle">Delivery breakdown</h2><button type="button" class="sz-dbk__x" data-sz-dbk-close aria-label="Close">'+IC.x+'</button></div>'+
        '<div class="sz-dbk__body"><div class="sz-dbk__tl"><span class="sz-dbk__line" aria-hidden="true"></span><ol class="sz-dbk__steps">'+
        step('cart','p','Order placed')+step('truck','s','Order shipped')+step('check','d','Order delivered')+'</ol></div>'+
        '<ul class="sz-dbk__pol">'+POLICY.map(function(t){return '<li>'+esc(t)+'</li>';}).join('')+'</ul></div>'+
        '<div class="sz-dbk__foot"><button type="button" class="sz-dbk__ok" data-sz-dbk-close>Got it</button></div></div>';
      document.body.appendChild(ov);
      dlg=ov.firstChild;
      ov.addEventListener('click',function(e){
        if(e.target===ov){close();return;}
        var c=e.target.closest&&e.target.closest('[data-sz-dbk-close]');if(c){e.preventDefault();close();}
      });
      ov.addEventListener('keydown',onKey);
    }
    function focusables(){return [].slice.call(dlg.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(function(e){return !e.disabled&&e.offsetParent!==null;});}
    function onKey(e){
      if(!isOpen)return;
      if(e.key==='Escape'||e.key==='Esc'){e.preventDefault();close();return;}
      if(e.key==='Tab'){
        var f=focusables();if(!f.length){e.preventDefault();dlg.focus();return;}
        var first=f[0],last=f[f.length-1],a=document.activeElement;
        if(e.shiftKey&&(a===first||a===dlg||!dlg.contains(a))){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&(a===last||!dlg.contains(a))){e.preventDefault();first.focus();}
      }
    }
    function fill(){
      var p=txt(['orderPlaced1','orderPlaced']),s=txt(['orderShips1','orderShips']),d=txt(['orderDelivered1','orderDelivered']);
      ov.querySelector('[data-k=p]').textContent=fmt(p);ov.querySelector('[data-k=s]').textContent=fmt(s);ov.querySelector('[data-k=d]').textContent=fmt(d);
    }
    function open(trigger){
      if(!ov)build();
      fill();clearTimeout(hideT);
      lastFocus=trigger||document.activeElement;
      ov.hidden=false;isOpen=true;
      document.documentElement.classList.add('sz-dbk-lock');
      void ov.offsetWidth; /* 1 lần reflow để transition chạy */
      ov.classList.add('is-open');
      var x=ov.querySelector('.sz-dbk__x');if(x)x.focus({preventScroll:true});
    }
    function close(){
      if(!isOpen)return;isOpen=false;
      ov.classList.remove('is-open');
      document.documentElement.classList.remove('sz-dbk-lock');
      hideT=setTimeout(function(){if(!isOpen)ov.hidden=true;},220);
      if(lastFocus&&lastFocus.focus){try{lastFocus.focus({preventScroll:true});}catch(err){}}
    }
    function isTrig(t){return t&&t.closest&&t.closest('#orderDelivered,[data-sz-dpop-open]');}
    function prep(){
      var d=document.getElementById('orderDelivered');
      if(d&&!d.hasAttribute('role')){d.setAttribute('role','button');d.setAttribute('tabindex','0');d.setAttribute('aria-haspopup','dialog');d.setAttribute('aria-label','See delivery breakdown');}
      if(d&&!d.__szFmt&&window.MutationObserver){
        d.__szFmt=1;fixLine();
        try{new MutationObserver(fixLine).observe(d,{childList:true,characterData:true,subtree:true});}catch(err){}
      }
    }
    document.addEventListener('click',function(e){var t=isTrig(e.target);if(!t)return;e.preventDefault();open(t);});
    document.addEventListener('keydown',function(e){
      if(isOpen)return;
      if(e.key!=='Enter'&&e.key!==' ')return;
      var t=e.target&&e.target.id==='orderDelivered'?e.target:null;if(!t)return;
      e.preventDefault();open(t);
    });
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',prep);else prep();
    window.szDeliveryBreakdown={open:open,close:close};
  }catch(err){if(window.console)console.warn('sz-delivery-pop',err);}
})();
